import "./CoBrand.css";

const CoBrand = () => {
  return (
    <div className="cobrand">
      <img className="brandlogo" src="/images/edhec-climate-institute.png" alt="EDHEC Climate Institute" />
      <div className="cbdiv" />
      <img className="cilogo" src="/images/climate-innov.png" alt="Climate Innov" />
    </div>
  );
};

export default CoBrand;
